module.exports = __webpack_public_path__ + "img/img40.0203a0b0.jpg";